export const PathwayStateType_Initial = 'initial';
export const PathwayStateType_Admit = 'admit';
export const PathwayStateType_Discharge = 'discharge';
export const PathwayStateType_Reassess = 'reassess';
export const PathwayStateType_Assessment = 'assessment';
export const PathwayStateType_Consult = 'consult';
export const DispositionTypes = [PathwayStateType_Admit, PathwayStateType_Discharge];
export const PathwayStateTypes = [...DispositionTypes, PathwayStateType_Initial, PathwayStateType_Reassess, PathwayStateType_Assessment, PathwayStateType_Consult];
export const EditableStateTypeTypes = [PathwayStateType_Assessment, PathwayStateType_Consult];
//# sourceMappingURL=types.js.map